module.exports = __webpack_public_path__ + "static/husky-71330d6da9fa4376addf5ed0f99ea2e9.jpg";